import { render, staticRenderFns } from "./OrgApplicationsPage.vue?vue&type=template&id=687251b8"
import script from "./OrgApplicationsPage.vue?vue&type=script&lang=js"
export * from "./OrgApplicationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports